import ky from "ky";
import RequestError from "@mittwald/api-client/dist/RequestError";
import checkIfResponseIsOk from "./ApiOperationResource/lib/checkIfResponseIsOk";
import { Resource } from "./Resource";
import { ResourceLoadingError } from "./ResourceLoadingError";
export class HttpResource extends Resource {
    constructor(url, options) {
        super(() => this.executeRequest(url, options));
    }
    async executeRequest(url, options = {}) {
        try {
            const response = await ky(url, {
                method: "get",
                ...options,
                throwHttpErrors: false,
            });
            checkIfResponseIsOk(response);
            return response.json();
        }
        catch (error) {
            if (error instanceof ResourceLoadingError) {
                throw error;
            }
            throw new RequestError(url, "GET", error);
        }
    }
}
export default HttpResource;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSHR0cFJlc291cmNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Jlc291cmNlcy9IdHRwUmVzb3VyY2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUE0QixNQUFNLElBQUksQ0FBQztBQUM5QyxPQUFPLFlBQVksTUFBTSx3Q0FBd0MsQ0FBQztBQUNsRSxPQUFPLG1CQUFtQixNQUFNLGdEQUFnRCxDQUFDO0FBQ2pGLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFDdEMsT0FBTyxFQUFFLG9CQUFvQixFQUFFLE1BQU0sd0JBQXdCLENBQUM7QUFJOUQsTUFBTSxPQUFPLFlBQWdCLFNBQVEsUUFBVztJQUM5QyxZQUFtQixHQUFXLEVBQUUsT0FBaUI7UUFDL0MsS0FBSyxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsR0FBRyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDakQsQ0FBQztJQUVPLEtBQUssQ0FBQyxjQUFjLENBQUMsR0FBVyxFQUFFLFVBQW1CLEVBQUU7UUFDN0QsSUFBSSxDQUFDO1lBQ0gsTUFBTSxRQUFRLEdBQUcsTUFBTSxFQUFFLENBQUMsR0FBRyxFQUFFO2dCQUM3QixNQUFNLEVBQUUsS0FBSztnQkFDYixHQUFHLE9BQU87Z0JBQ1YsZUFBZSxFQUFFLEtBQUs7YUFDdkIsQ0FBQyxDQUFDO1lBRUgsbUJBQW1CLENBQUMsUUFBUSxDQUFDLENBQUM7WUFFOUIsT0FBTyxRQUFRLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDekIsQ0FBQztRQUFDLE9BQU8sS0FBSyxFQUFFLENBQUM7WUFDZixJQUFJLEtBQUssWUFBWSxvQkFBb0IsRUFBRSxDQUFDO2dCQUMxQyxNQUFNLEtBQUssQ0FBQztZQUNkLENBQUM7WUFFRCxNQUFNLElBQUksWUFBWSxDQUFDLEdBQUcsRUFBRSxLQUFLLEVBQUUsS0FBSyxDQUFDLENBQUM7UUFDNUMsQ0FBQztJQUNILENBQUM7Q0FDRjtBQUVELGVBQWUsWUFBWSxDQUFDIn0=